import { useEffect, useState } from 'react'
import WrapperPageSimple from '../WrapperPage/present/WrapperPageSimple'
import config from '../../config.json'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import Translation, { getTranslationString } from '../Translation/cont/Translation'
import RadioButtonWrapper from '../forms/fields/RadioButtonWrapper'
import FieldWrapper from '../forms/FieldWrapper'
import SignageFilterSelectContainer from '../../containers/PageSignageLite/SignageFilterSelectContainer'
import ButtonSubmit from '../general/ButtonSubmit'
import { MULTICINEMA } from '../../constants/cinemaTypes'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import Button from '../general/Button'
import ImageDisplayAndUpload from '../forms/fields/ImageDisplayAndUpload'
import CheckboxMovieItem from '../forms/fields/MultiSelectCheckboxMovieItem'
import encodeHtml from '../../functions/encodeHtml'
import getDateObj from '../../functions/getDateObj'
import getPeriodeEndDate from '../../functions/getPeriodeEndDate'

const PageSignageLitePage = ({pageName, cinemas, cliCinemasIdList, sortedMovieDataKeys, movieData, currentFrontCinemaId, currentLang, routesData, attributes}) => {
    const [signageLink, generateSignageLink] = useState(null)
    const [isCopied, setCopied] = useState(false)

    useEffect(() => {
        const timeOutId = setTimeout(() => setCopied(false), 2500)
    
        return () => {
            if(timeOutId) {
                clearTimeout(timeOutId)
            }
        }
    })
    const {program_overview} = routesData
    const programOverviewUri = program_overview[currentLang] ? program_overview[currentLang].uri : ""
    const timeFilter = ['no_timeframe', 'today', 'tomorrow', 'week', 'customWeek']
    const frontCinemaIsMultiCinema = cinemas[currentFrontCinemaId] && cinemas[currentFrontCinemaId].scope.type === MULTICINEMA

    const initValues = {
        cinema: frontCinemaIsMultiCinema ? '' : currentFrontCinemaId,
        fsk: "",
        genres: "",
        technical: "",
        theatres: "",
        time: "",
        weekCounter: "", 
        title: "",
        cinemaInfos: false,
        backgroundColor: '',
        color: '',
        showLogo: true,
        alternativeLogo:'',
        displayVariant: 'displayVariantDefault',
        displayVariantDefault: {
            style: 'poster',
            movies: [],
            displays: 1
        },
        displayVariantSingle: {
            style: 'poster',
            movies: [],
            timeout: 10,
        }
    }
    
    const displayVariants = { 
        displayVariantDefault: {
            name: 'Mehrere Filme auf einem Bildschirm',
            id: "displayVariantDefault"
        },
        displayVariantSingle: {
            name: 'Ein Film auf einem Bildschirm (Optimal im Hochformat)',
            id: "displayVariantSingle"
        }
    }
    
    const displayVariantDefaultStyles = {
        poster: {
            name: 'Filme mit Postern (Optimal im Querformat)',
            id: "poster"
        },
        list: {
            name: 'einfache Filmliste (Optimal im Hochformat)',
            id: "list"
        }
    }

    return (
        <WrapperPageSimple pageTitleTransId={config.routes.signagelite.transId} pageTitle={pageName}>
            <div className="signage-lite-settings-page site-content">
            <Formik
                initialValues={initValues}
                onSubmit={(values, actions) => {
                    let signageQuerys = ""
                    let displayCounter = 1

                    _.keys(values).map(valueKey => {
                        const id = valueKey
                        const name = values[valueKey]
                        
                        if(name !== '') {
                            let filterString = ''
                            if(id === 'theatres') {
                                filterString = "&theatreName=" + name
                            } else if((id === 'displayVariantDefault' || id === "displayVariantSingle")) {
                                if (values.displayVariant === id) {
                                    const choosenVariant = values[values.displayVariant]
                                    _.keys(choosenVariant).map(variantKey => {
                                        const id = variantKey
                                        const name = choosenVariant[variantKey]

                                        let variantFilterString = ''
                                        if(id === 'movies') {
                                            if(name.length !== 0) {
                                                variantFilterString = id + "=" + name.toString() 
                                            }
                                        } else {
                                            if(id === 'displays') {
                                                displayCounter = name
                                            }
                                            variantFilterString = id + "=" + name 
                                        }
                                        
                                        if(signageQuerys === "") {
                                            signageQuerys = variantFilterString
                                        } else {
                                            signageQuerys = signageQuerys.concat('&' + variantFilterString)
                                        }
                                    })
                                }
                            } else if(id === "alternativeLogo") {
                                filterString = id + "=" + encodeURIComponent(name.url)
                            } else {
                                filterString = id + "=" + encodeHtml(name)
                            }

                            if(filterString) {
                                if(signageQuerys === "") {
                                    signageQuerys = '?' + filterString
                                } else {
                                    signageQuerys = signageQuerys.concat('&' + filterString)
                                }
                            }
                        }
                    })

                    let generatedUrl
                    const signageLinks = []

                    if(displayCounter > 1) {
                        for(let i = 0; i < displayCounter; i++)  {
                            const generatedUrlPerScreen = programOverviewUri + "signage/" + signageQuerys + '&displayNumber=' + (i + 1)
                            signageLinks.push(generatedUrlPerScreen)
                        }
                    } else {
                        generatedUrl = programOverviewUri + "signage/" + signageQuerys
                        signageLinks.push(generatedUrl)
                    }

                    generateSignageLink(signageLinks)
                }}
            >
            {({values, errors, touched, isSubmitting, handleReset, setFieldValue}) => 
                <Form>
                    <div className={"form-content signage"}>
                        {_.has(values, "cinema") && cinemas && frontCinemaIsMultiCinema && cliCinemasIdList.length > 1 ? (
                            <fieldset className="field-cinemas">
                                <legend className="field-text-label choose-cinema"><Translation id="choose_cinema"/></legend>                                              
                                <div className="grid-container">
                                    <div key={'field_no-cinema'} className="field-checkbox">
                                        <RadioButtonWrapper id={'no-cinema'} label={<Translation id="choose_allcinemas"/>}>
                                            <Field
                                                id={'no-cinema'}
                                                type="radio"
                                                name="cinema"
                                                value={''}
                                            />
                                        </RadioButtonWrapper>
                                    </div>
                                    {cliCinemasIdList.map(cinemaId => {
                                        const cinema = cinemas[cinemaId]
                                        const {pk, nameDisplay} = cinema

                                        return (
                                            <div key={'field' + pk} className="field-checkbox">
                                                <RadioButtonWrapper id={pk} label={nameDisplay}>
                                                    <Field
                                                        id={pk}
                                                        type="radio"
                                                        name="cinema"
                                                        value={pk}
                                                    />
                                                </RadioButtonWrapper>
                                            </div>
                                        )
                                    })}
                                </div>
                                </fieldset>
                            ) : (
                                ''
                            )
                        }
                        <FieldWrapper label={<Translation id="content_title"/>} id="title" classes="field-text">
                            <Field type="text" name="title" id="title" className="text-regular input-text-box" />
                            <ErrorMessage name="title" component="div" /> 
                        </FieldWrapper>

                        <FieldWrapper label={<Translation id="style_newsletterBackground"/>} id="backgroundColor" classes="field-text">
                            <Field type="text" name="backgroundColor" id="backgroundColor" className="text-regular input-text-box" />
                            <ErrorMessage name="backgroundColor" component="div" /> 
                        </FieldWrapper>

                        <FieldWrapper label={<Translation id="print_flyer_text_color"/>} id="color" classes="field-text">
                            <Field type="text" name="color" id="color" className="text-regular input-text-box" />
                            <ErrorMessage name="color" component="div" /> 
                        </FieldWrapper>

                        <div className='field-text'>
                            <label>
                                <p className='gap-10'><Translation id="logo">Logo</Translation></p>
                            
                                <Field type="checkbox" checked={values.showLogo} id="active-title-top-text" className="checkbox tgl tgl-flat" onChange={() => {
                                    setFieldValue('showLogo', !values.showLogo)
                                }}/>
                                <span className="tgl-btn text-regular"><span className='screen-reader-text'><Translation id="print_flyer_activate_customization">Aktiv</Translation></span></span>
                            </label>
                        </div>

                        {values.showLogo &&  <FieldWrapper classes="image field-text" label={<Translation id="alternative_logo"/>} id="alternativeLogo" >
                            <Field 
                                name="alternativeLogo"
                                component={ImageDisplayAndUpload}
                            />
                        </FieldWrapper>}

                        <div className='field-text'>
                            <label>
                                <p className='gap-10'><Translation id="display_cinema_info">Logo</Translation></p>
                            
                                <Field type="checkbox" checked={values.cinemaInfos} id="active-title-top-text" className="checkbox tgl tgl-flat" onChange={() => {
                                    setFieldValue('cinemaInfos', !values.cinemaInfos)
                                }}/>
                                <span className="tgl-btn text-regular"><span className='screen-reader-text'><Translation id="print_flyer_activate_customization">Aktiv</Translation></span></span>
                            </label>
                        </div>
                        {(values.displayVariantDefault.movies.length === 0 && values.displayVariantSingle.movies.length === 0) && <div className='field-text'>
                            <legend className="field-text-label set-timeframe"><Translation id="formik_datepicker_set_timeframe"/></legend>             
                            <div className='timeframe'>
                                {timeFilter.map((filterKey, index) => {
                                    const value = filterKey === "no_timeframe" ? '' : filterKey
                                    if(filterKey === "customWeek") {
                                        return (
                                            <div className="field-checkbox custom-week-wrapper" key={index}>
                                                <RadioButtonWrapper id={filterKey} label={<Translation id={"formik_datepicker_" + filterKey}/>}>
                                                    <Field
                                                        id={filterKey}
                                                        type="radio"
                                                        name="time"
                                                        value={value}
                                                    />
                                                </RadioButtonWrapper>
                                                {values.time === "customWeek" && <FieldWrapper label={<Translation id="signage_filter_time_week_counter"/>} id="weekCounter" classes="field-text">
                                                    <Field type="text" name="weekCounter" id="weekCounter" className="text-regular input-text-box" />
                                                    <ErrorMessage name="weekCounter" component="div" /> 
                                                </FieldWrapper>}
                                            </div>
                                        )
                                    } else {
                                        return <div className="field-checkbox" key={index}>
                                            <RadioButtonWrapper id={filterKey} label={<Translation id={"formik_datepicker_" + filterKey}/>}>
                                                <Field
                                                    id={filterKey}
                                                    type="radio"
                                                    name="time"
                                                    value={value}
                                                />
                                            </RadioButtonWrapper>
                                        </div>
                                    }
                                })}
                            </div>
                        </div>}
                        {values.cinema && attributes[values.cinema] ? (
                            <div className='field-text more-filter-wrapper'>
                                {_.keys(attributes[values.cinema]).map((filterKey, index) => {
                                    const filterItems = attributes[values.cinema][filterKey]
                                    return _.keys(filterItems).length !== 0 && <SignageFilterSelectContainer 
                                        filterItems={filterItems}
                                        values={values}
                                        name={filterKey}
                                        transId={filterKey}
                                        key={index}
                                    /> 
                                })}    
                            </div>
                        ) : (
                            <div className='field-text more-filter-wrapper'>
                            {_.keys(attributes.global).map((filterKey, index) => {
                                const filterItems = attributes.global[filterKey]
                                return _.keys(filterItems).length !== 0 && <SignageFilterSelectContainer 
                                    filterItems={filterItems}
                                    values={values}
                                    name={filterKey}
                                    transId={filterKey}
                                    key={index}
                                /> 
                            })}    
                        </div>
                        )}
                        <div className='field-text more-filter-wrapper'>
                            <SignageFilterSelectContainer 
                                filterItems={displayVariants}
                                values={values}
                                transId={"displayVariant"}
                                name={"displayVariant"}
                            />     
                        </div>
                        {(values.displayVariant && values.displayVariant === 'displayVariantDefault') && <div className='field-text'>
                            <SignageFilterSelectContainer 
                                filterItems={displayVariantDefaultStyles}
                                values={values}
                                transId={"displayVariantDefaultStyles"}
                                name={"displayVariantDefault.style"}
                            />     
                            <FieldWrapper label={<Translation id="signage_filter_displayVariantDefault_numbers"/>} id="displayVariantDefault.displays" classes="field-text">
                                <Field type="number" name="displayVariantDefault.displays" id="displayVariantDefault.displays" className="text-regular input-text-box" />
                                <ErrorMessage name="displayVariantDefault.displays" component="div" /> 
                            </FieldWrapper>

                            {!values.time ? sortedMovieDataKeys && !_.isEmpty(movieData) && sortedMovieDataKeys.length > 0 ? (
                                <div className={"input-field select-new-section-type field-text"}>
                                    <fieldset>
                                        <legend>
                                            <Translation id="highlight_movie_link" after="*">Filmverknüpfung</Translation>
                                        </legend>

                                        <div className="radio-button-wrapper">
                                            <div className="radio-button-group-wrapper">
                                                {sortedMovieDataKeys.map((movieID) => {
                                                    const movie = movieData[movieID]
                                                    const intId = movie.id
                                                    const {cinemaIds, title} = movie
                                                    const containsCinema = _.contains(cinemaIds, values.cinema)
                                                    
                                                    if((containsCinema && values.cinema !== '') || values.cinema === '') {
                                                        return (
                                                            <Field
                                                                key={intId}
                                                                component={CheckboxMovieItem}
                                                                name="displayVariantDefault.movies"
                                                                id={intId}
                                                                movie={movie}
                                                                label={title}
                                                            />
                                                        )
                                                    } else {
                                                        return ''
                                                    }
                                                })}
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
                            ) : (
                                <p>Keine Filme verfügbar.</p>
                            ) : (
                                ''
                            )}
                        </div>}
                        {(values.displayVariant && values.displayVariant === 'displayVariantSingle') && <div className='field-text'>
                            <FieldWrapper label={<Translation id="signage_filter_displayVariantDefault_timeout"/>} id="displayVariantSingle.timeout" classes="field-text">
                                <Field type="number" name="displayVariantSingle.timeout" id="displayVariantSingle.timeout" className="text-regular input-text-box" />
                                <ErrorMessage name="displayVariantSingle.timeout" component="div" /> 
                            </FieldWrapper>

                            {!values.time ? sortedMovieDataKeys && !_.isEmpty(movieData) && sortedMovieDataKeys.length > 0 ? (
                                <div className={"input-field select-new-section-type field-text"}>
                                    <fieldset>
                                        <legend>
                                            <Translation id="highlight_movie_link" after="*">Filmverknüpfung</Translation>
                                        </legend>

                                        <div className="radio-button-wrapper">
                                            <div className="radio-button-group-wrapper">
                                                {sortedMovieDataKeys.map((movieID) => {
                                                    const movie = movieData[movieID]
                                                    const intId = movie.id
                                                    const {cinemaIds, title} = movie
                                                    const containsCinema = _.contains(cinemaIds, values.cinema)
                                                    
                                                    if((containsCinema && values.cinema !== '') || values.cinema === '') {
                                                        return (
                                                            <Field
                                                                key={intId}
                                                                component={CheckboxMovieItem}
                                                                name="displayVariantSingle.movies"
                                                                id={intId}
                                                                movie={movie}
                                                                label={title}
                                                            />
                                                        )
                                                    } else {
                                                        return ''
                                                    }
                                                })}
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
                            ) : (
                                <p>Keine Filme verfügbar.</p>
                            ) : (
                                ''
                            )}
                        </div>}
                    </div>

                    {signageLink && signageLink.length !== 0 && signageLink.map((link, index) => {
                        return <div key={index} className="field-text">
                        <div className="copy-wrapper">
                            <FieldWrapper info={signageLink.length > 1 && "Screen " + (index + 1)} label={<Translation id="signage_filter_generated_link"/>} id="signage-link" classes="field-text">
                                <input 
                                    id="signage-link"
                                    type="url" 
                                    readOnly={true}  
                                    value={link}
                                    className='text-regular input-text-box'
                                />
                            </FieldWrapper>
                            <CopyToClipboard
                                text={link} 
                                onCopy={() => setCopied(index)}
                            >
                                <Button
                                    className="copy-button button text-medium cursor-pointer"
                                    transId={"signage_copy_url"}
                                    type="button"
                                    hideText={false}
                                />
                            </CopyToClipboard>
                        </div>
                        {isCopied === index && <div className="copy-success text-small-medium ">
                            <Translation id="signage_copy_url_to_clipboard"/>
                        </div>}
                    </div>
                    })}

                    <ButtonSubmit
                        transIdSubmit={'signage_filter_create_link'}
                        onSubmit={() => {}}
                        disableTemporarily={false}
                        disablePermanently={false}
                    />
                </Form>
            }
        </Formik>
            </div>
        </WrapperPageSimple>
    )
}

export default PageSignageLitePage  